import React from "react";
import CampusDashboard from "../superadmin/CampusDashboard";

function ViewerCampusAnalyticsPage({ onLogout, showToast, students }) {
  return (
    <CampusDashboard
      onLogout={onLogout}
      showToast={showToast}
      students={students}
      analyticsOnly
    />
  );
}

export default ViewerCampusAnalyticsPage;
